import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './utils/fontawesome/config';
// i18n
import './i18n';
// Styles
import './styles/fonts.css';
import './styles/reset.css';
import './styles/theme.css';
import './styles/utils.css';
import './styles/react-date-range.css';

// react-date-range
import 'react-date-range/dist/styles.css';
import 'react-date-range/dist/theme/default.css';

// @ts-ignore
ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
